/**
 * Error thrown when component props fail schema validation.
 */
export class ValidationError extends Error {
  constructor(
    componentType: string,
    public readonly issues: Array<{ path: string; message: string }>,
  ) {
    const issueList = issues.map((i) => `  - ${i.path}: ${i.message}`).join('\n');
    super(`Invalid props for ${componentType}:\n${issueList}`);
    this.name = 'ValidationError';
  }
}
